import React from 'react';
import Lottie from 'react-lottie';
import './Recharge_card_lottie_animation.css';


function Recharge_card_lottie_animation({defaultOptions}) {
 

  return (
    <section className='main'>
      <div className='Recharge_card_lottie_icon'>
        <Lottie className="me-auto"
          options={defaultOptions}
        />
      </div>
    </section>
  );
}
export default Recharge_card_lottie_animation;